document.addEventListener('DOMContentLoaded', () => {
  const toggleTitles = document.querySelectorAll('h1.toggle-next, h2.toggle-next, h3.toggle-next');

  toggleTitles.forEach(title => {
    const nextEl = title.nextElementSibling;

    if (nextEl && nextEl.classList.contains('wp-block-group')) {
      // Réinitialisation
      nextEl.classList.remove('toggle-hidden', 'toggle-display');
      nextEl.style.overflow = 'hidden';

      // Déterminer l'état initial
      let state;
      if (title.classList.contains('toggle-next-hide')) {
        state = 'hidden';
      } else if (title.classList.contains('toggle-next-display')) {
        state = 'display';
      } else if (nextEl.classList.contains('toggle-hidden')) {
        state = 'hidden';
      } else if (nextEl.classList.contains('toggle-display')) {
        state = 'display';
      } else {
        state = 'display';
      }

      // Appliquer l'état
      if (state === 'hidden') {
        nextEl.style.height = '0px';
        nextEl.classList.add('toggle-hidden');
        title.setAttribute('data-open', 'false');
      } else {
        nextEl.style.height = `${nextEl.scrollHeight}px`;
        nextEl.classList.add('toggle-display');
        title.setAttribute('data-open', 'true');
      }

      // Accessibilité
      title.setAttribute('tabindex', '0');
      title.setAttribute('role', 'button');
      title.setAttribute('aria-expanded', state === 'display' ? 'true' : 'false');

      // Fonction de toggle
      const toggleBlock = () => {
        const isOpen = nextEl.classList.contains('toggle-display');

        if (isOpen) {
          // Fermer avec transition height
          nextEl.style.height = `${nextEl.scrollHeight}px`;

          requestAnimationFrame(() => {
            nextEl.style.height = '0px';

            const onTransitionEnd = (e) => {
              if (e.propertyName === 'height') {
                nextEl.removeEventListener('transitionend', onTransitionEnd);
                nextEl.classList.remove('toggle-display');
                nextEl.classList.add('toggle-hidden');
                title.setAttribute('data-open', 'false');
                title.setAttribute('aria-expanded', 'false');
              }
            };

            nextEl.addEventListener('transitionend', onTransitionEnd);
          });
        } else {
          // Ouvrir
          nextEl.classList.remove('toggle-hidden');
          nextEl.classList.add('toggle-display');
          nextEl.style.height = '0px';

          requestAnimationFrame(() => {
            nextEl.style.height = `${nextEl.scrollHeight}px`;
          });

          title.setAttribute('data-open', 'true');
          title.setAttribute('aria-expanded', 'true');
        }
      };

      // Clic et clavier
      title.addEventListener('click', toggleBlock);
      title.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleBlock();
        }
      });

      // Nettoyage height auto après ouverture
      nextEl.addEventListener('transitionend', (e) => {
        if (e.propertyName === 'height' && nextEl.classList.contains('toggle-display')) {
          nextEl.style.height = 'auto';
        }
      });
    }
  });
});
